import { HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';

const FALLBACK_ORIGIN = 'http://localhost';

const getBrowserOrigin = (): string => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return FALLBACK_ORIGIN;
};

const parseConfiguredUrl = (value: string): URL | null => {
  const normalizedValue = typeof value === 'string' ? value.trim() : '';
  if (!normalizedValue) {
    return null;
  }

  try {
    return new URL(normalizedValue, getBrowserOrigin());
  } catch {
    return null;
  }
};

const parseRequestUrl = (value: string): URL | null => {
  const normalizedValue = typeof value === 'string' ? value.trim() : '';
  if (!normalizedValue) {
    return null;
  }

  try {
    return new URL(normalizedValue, getBrowserOrigin());
  } catch {
    return null;
  }
};

const normalizeBasePath = (pathname: string): string => {
  if (!pathname || pathname === '/') {
    return '/';
  }

  return pathname.endsWith('/') ? pathname : `${pathname}/`;
};

const isRestPath = (pathname: string, basePath = '/'): boolean => {
  const normalizedBasePath = normalizeBasePath(basePath);

  if (normalizedBasePath === '/') {
    return pathname === '/rest' || pathname.startsWith('/rest/');
  }

  const restBasePath = `${normalizedBasePath}rest`;
  return pathname === restBasePath || pathname.startsWith(`${restBasePath}/`);
};

export const isTrustedApiRequest = (requestUrl: string): boolean => {
  const parsedRequestUrl = parseRequestUrl(requestUrl);
  if (!parsedRequestUrl) {
    return false;
  }

  const parsedServerUrl = parseConfiguredUrl(environment.serverUrl);
  if (
    parsedServerUrl &&
    parsedRequestUrl.origin === parsedServerUrl.origin &&
    isRestPath(parsedRequestUrl.pathname, parsedServerUrl.pathname)
  ) {
    return true;
  }

  return (
    parsedRequestUrl.origin === getBrowserOrigin() &&
    isRestPath(parsedRequestUrl.pathname)
  );
};

export const stripQueryParams = (
  params: HttpParams | undefined,
  keys: string[]
): HttpParams =>
  keys.reduce(
    (currentParams, key) => currentParams.delete(key),
    params ?? new HttpParams()
  );
